// extracted by mini-css-extract-plugin
export default {"cardContainer":"DigitalCard_cardContainer__Qx+Su","advantageCategory":"DigitalCard_advantageCategory__LUjqv"};